import { CauseState } from "./causes.types";

export const initialState: CauseState = {
  data: [],
  loading: false,
  error: null,
};